module.exports = __webpack_public_path__ + "img/home.0d33d4e7.png";